// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_KET","cls2":"CiterightMiniReport-cls2_RYD CiterightMiniReport-cls1_KET"};